import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import CompanyProfileView from '../../../../views/Customer/CompanyProfileView';

const ProfileRoute = () => {
	return (	
		<Routes>
			<Route
				path=""
				element={<CompanyProfileView />}
			/>			
		</Routes>	
	);
};

export default ProfileRoute;
